module.exports = __webpack_public_path__ + "static/media/silestone-white.c2ed3fda.svg";